module.exports = __webpack_public_path__ + "static/img/brij.2baae3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/brij.png
// module id = 496
// module chunks = 1